// Model.js
// -----------------------
// @module Case
define("Eureka.MaxaPartPicker.MaxaPartPicker.Model", ["Backbone", "Utils", "AjaxRequestsKiller"], function(
    Backbone,
    Utils,
    AjaxRequestsKiller
) {
    "use strict";

    // @class Case.Fields.Model @extends Backbone.Model
    return Backbone.Model.extend({

        
        //@property {String} urlRoot
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                "services/MaxaPartPicker.Service.ss"
            )
        )

        , findBrands: function(data){
            this.set({
                brands: true,
                models: false,
                getall: false
            });
            this.attributes.data = data
            var promise = this.sync('update', this, {killerId: AjaxRequestsKiller.getKillerId()})
            return promise.done()
        }

        , findModels: function(brandId, typeId){
            this.set({
                models: true,
                brands: false,
                getall: false
            });
            this.attributes.brandId = brandId
            this.attributes.typeId = typeId
            var promise = this.sync('update', this, {killerId: AjaxRequestsKiller.getKillerId()})
            return promise.done()
        }

        , getAll: function (typeId, brandId){
            this.set({
                models: false,
                brands: false,
                getall: true
            })
            this.attributes.brandId = brandId
            this.attributes.typeId = typeId
            var promise = this.sync('update', this, {killerId: AjaxRequestsKiller.getKillerId()})
            return promise.done()
        }
        
});
});
